import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export const menuItem = [
    {
        name: 'اطلاعات عمومی',
        icon: 'feather-info',
        description: 'اطلاعات عمومی اشخاص، شعب، ویژگی‌ها، مراکز هزینه، حساب‌های بانکی و کالاها و خدمات',
        children: [
            { name: 'اشخاص', path: '/profile/users/', description: 'مدیریت اشخاص طرف معامله' },
            { name: 'شعب اشخاص', path: '/profile/branches/', description: 'مدیریت شعب اشخاص طرف معامله' },
            { name: 'ویژگی‌ها', path: '/profile/features/', description: 'مدیریت ویژگی‌های سیستم' },
            { name: 'مراکز هزینه', path: '/profile/price/centers/', description: 'مدیریت مراکز هزینه' },
            { name: 'حساب‌های بانکی', path: '/profile/bank/accounts/', description: 'مدیریت حساب‌های بانکی' },
            { name: 'کالاها و خدمات', path: '/products/management/', description: 'مدیریت کالاها و خدمات برای استفاده در صورتحساب' },
            {
                name: 'نرم افزار حسابداری',
                path: '/accounting/module/',
                description: 'نرم افزار حسابداری (فعال در صورت خریداری ماژول)',
                condition: 'module_accounting_persons'
            },
        ]
    },
    {
        name: 'اطلاعات پایه',
        icon: 'feather-database',
        description: 'اطلاعات پایه سیستم شامل حساب‌ها، قراردادها، فعالیت‌ها و ...',
        children: [
            { name: 'گروه حساب‌ها', path: '/base/accounts/group/', description: 'مدیریت گروه حساب‌ها' },
            { name: 'حساب‌های کل', path: '/base/accounts/all/', description: 'مدیریت حساب‌های کل' },
            { name: 'حساب‌های معین', path: '/base/accounts/moein/', description: 'مدیریت حساب‌های معین' },
            { name: 'حساب‌های', path: '/base/accounts/s/', description: 'مدیریت حساب ها' },
            { name: 'قراردادها', path: '/base/agreements/', description: 'مدیریت قراردادها' },
            { name: 'فعالیت‌ها', path: '/base/activities/', description: 'مدیریت فعالیت‌ها' },
            { name: 'رده تایید', path: '/base/classify/confirmation/', description: 'مدیریت رده‌های تایید' },
            { name: 'سمت‌ها', path: '/base/positions/', description: 'مدیریت سمت‌ها' },
            { name: 'فرم‌ها', path: '/base/forms/', description: 'مدیریت فرم‌ها' },
        ]
    },
    {
        name: 'عملیات',
        icon: 'feather-play-circle',
        description: 'عملیات‌های اصلی سیستم',
        children: [
            { name: 'ثبت فعالیت', path: '/action/submit/activity/', description: 'ثبت فعالیت جدید' },
            { name: 'اصلاح فعالیت', path: '/action/correction/activity/', description: 'اصلاح فعالیت‌های ثبت شده' },
            { name: 'لیست اسناد حسابداری', path: '/action/accounting/document/', description: 'لیست اسناد حسابداری' },
            { name: 'اصلاح اسناد حسابداری', path: '/action/accounting/correction/', description: 'اصلاح اسناد حسابداری' },
        ]
    },
    {
        name: 'گزارشات',
        icon: 'feather-bar-chart-2',
        description: 'گزارشات و تحلیل‌های سیستم',
        children: [
            { name: 'اسناد حسابداری', path: '/reports/accounting/documents/', description: 'گزارش اسناد حسابداری' },
            { name: 'ترازها', path: '/reports/balance/', description: 'گزارش ترازها' },
            { name: 'گردش حساب‌ها', path: '/reports/accounts/circulation/', description: 'گزارش گردش حساب‌ها' },
            { name: 'مرور حساب‌ها', path: '/reports/review/accounts/', description: 'مرور حساب‌ها' },
        ]
    },
    {
        name: 'اطلاعات پایه',
        icon: 'feather-file-text',
        description: 'اطلاعات پایه سیستم شامل انواع صورتحساب، الگوهای صورتحساب، اقلام صورتحساب، روش‌های تسویه، لیست صورتحساب‌ها، صدور صورتحساب',
        children: [
            { name: 'انواع صورتحساب', path: '/invoice/type/', description: 'مدیریت انواع صورتحساب' },
            { name: 'الگوهای صورتحساب', path: '/invoice/patterns/', description: 'مدیریت الگوهای صورتحساب' },
            { name: 'اقلام صورتحساب', path: '/invoice/patterns/', description: 'مدیریت اقلام صورتحساب' },
            { name: 'روش‌های تسویه', path: '/invoice/method/', description: 'مدیریت روش‌های تسویه' },
        ]
    },
    {
        name: 'عملیات',
        icon: 'feather-play-circle',
        description: 'عملیات ها',
        children: [
            { name: 'لیست صورتحساب‌ها', path: '/invoices/list/', description: 'مشاهده لیست صورتحساب‌ها' },
            { name: 'صدور صورتحساب', path: '/invoices/issuance/', description: 'صدور صورتحساب' },
        ]
    },
    {
        name: 'امکانات',
        icon: 'feather-settings',
        description: 'تنظیمات و امکانات سیستم',
        children: [
            { name: 'کاربران', path: '/facilities/users/', description: 'مدیریت کاربران سیستم' },
            { name: 'دسترسی کاربران', path: '/facilities/users/permission/', description: 'مدیریت دسترسی کاربران' },
            { name: 'انتخاب دوره', path: '/facilities/course/select/', description: 'انتخاب دوره مالی' },
            { name: 'تنظیمات', path: '/facilities/settings/', description: 'تنظیمات سیستم' },
        ]
    },
];

export const menuItems = [
    {
        name: 'داشبورد',
        icon: 'feather-home',
        path: '/dashboard/',
        isSingle: true,
        description: 'بررسی مشخصات اصلی بنگاه اقتصادی حساب کاربری'
    },
    {
        name: 'کالاها و خدمات',
        icon: 'feather-archive',
        description: 'مدیریت و تعریف کالاها و خدمات سازمان',
        children: [
            { name: 'مدیریت کالاها و خدمات', path: '/products/management/', description: 'از این قسمت شما می توانید کالاها و خدمات خود را جهت استفاده در صورتحساب وارد نمائید.' },
            { name: 'واحد اندازه گیری', path: '/products/units/', description: 'در این قسمت واحدهای اندازه گیری که جهت استفاده در صورتحساب ، مورد نیاز است نمایش می یابد . شما تنها مجاز به استفاده از این واحدها هستید.' },
        ]
    },
    {
        name: 'اشخاص',
        icon: 'feather-user',
        description: 'مدیریت پروفایل، شعب و اشخاص مرتبط',
        children: [
            { name: 'فهرست اشخاص', path: '/profile/users/', description: 'در این قسمت شما می توانید اشخاص طرف معامله خود را وارد نمائید.' },
        ]
    },
    /* TEMP-HIDDEN: صندوق پستی — restore when needed
    {
        name: 'ارتباطات و اعلان‌ها',
        icon: 'feather-mail',
        description: 'مشاهده پیام‌ها و اعلان‌های سیستم',
        children: [
            { name: 'صندوق پستی', path: '/notifications/', description: 'مشاهده اعلان‌های دریافتی، فاکتورها و پیام‌های سیستم' },
        ]
    },
    */
    {
        name: 'فاکتورها',
        icon: 'feather-file-text',
        description: 'مدیریت کامل فرآیند صدور و پیگیری فاکتورها',
        children: [
            { name: 'اقلام صورتحساب', path: '/invoice/fields/', description: 'در این قسمت اقلام اطلاعاتی مورد نیاز در هنگام صدور صورتحساب ، نمایش می باید . برخی از اقلام ، می بایست در صورتحساب درج گردد که بصورت پیش فرض فعال می باشد . شما می توانید بر حسب نیاز اقلام مورد نیاز خود را فعال نموده تا در صورتحساب نمایش یابد' },
            { name: 'صدور صورتحساب', path: '/invoice/issuance/', description: 'در این قسمت عملیات اصلی نرم افزار انجام می شود.' },
            { name: 'لیست صورتحساب', path: '/invoices/list/', description: 'در این قسمت لیست صورتحسابهای صادر شده نمایش می یابد.' },
            { name: 'الگو‌های صورتحساب', path: '/invoice/pattern/', description: 'در این قسمت الگوهای قابل استفاده در هنگام صدور صورتحساب الکترونیکی ، نمایش می یابد' },
            { name: 'انواع صورتحساب', path: '/invoice/type/', description: 'در این قسمت انواع صورتحسابهایی که قابل صدور است نمایش می یابد.' },
            { name: 'روش‌های تسویه', path: '/invoice/method/', description: 'در این قسمت انواع روش های تسویه که در هنگام صدور صورتحساب ، مورد نیاز است نمایش می یابد.' },
            /* TEMP-HIDDEN: صدور فرم خرید صورتحساب — restore when needed
            { name: 'صدور فرم خرید صورتحساب', path: '/purchase/form/', description: 'در این قسمت میتوانید برای یک صورتحساب فرم خرید صادر کنید و سند حسابداری آن را ثبت و خروجی PDF بگیرید.' },
            */
        ]
    },
    {
        name: "کشور، استان و شهر",
        icon: "feather-map-pin",
        description: 'در این قسمت اطلاعات مربوط به کشور ، استان و شهر که در هنگام صدور صورتحساب نیاز است نمایش می یابد.',
        children: [
            { name: "کشور", path: "/location/country/", description: 'مدیریت و انتخاب کشورهای فعال در سیستم' },
            { name: "استان", path: "/location/province/", description: 'مدیریت و دسته‌بندی استان‌های کشور' },
            { name: "شهر", path: "/location/city/", description: 'مدیریت و دسته‌بندی شهرهای تابعه هر استان' },
        ],
    }
];

function Sidebar() {
    const location = useLocation();
    const currentPath = location.pathname.endsWith('/') ? location.pathname : location.pathname + '/';

    const handleLogout = (e) => {
        e.preventDefault();
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('user_data');
        window.location.href = '/login/';
    };

    const renderMenuItem = (item) => {
        if (item.name === 'خروج') {
            return (
                <li key={item.path} className="nxl-item">
                    <a
                        href="#"
                        className="nxl-link sidebar-tooltip"
                        onClick={handleLogout}
                        data-bs-toggle="tooltip"
                        data-bs-trigger="hover"
                        data-bs-placement="left"
                        data-bs-container="body"
                        data-bs-title="خروج از حساب کاربری و بازگشت به صفحه ورود"
                    >
                        <span className="nxl-micon"><i className={item.icon}></i></span>
                        <span className="nxl-mtext">{item.name}</span>
                    </a>
                </li>
            );
        }

        if (item.isSingle) {
            const isActive = currentPath === item.path || currentPath.startsWith(item.path);
            return (
                <li key={item.path} className={`nxl-item ${isActive ? 'active' : ''}`}>
                    <Link
                        to={item.path}
                        className="nxl-link sidebar-tooltip"
                        data-bs-toggle="tooltip"
                        data-bs-trigger="hover"
                        data-bs-placement="left"
                        data-bs-container="body"
                        data-bs-title={item.description}
                    >
                        <span className="nxl-micon"><i className={item.icon}></i></span>
                        <span className="nxl-mtext">{item.name}</span>
                    </Link>
                </li>
            );
        }

        const isActiveParent = item.children.some(child => currentPath === child.path || currentPath.startsWith(child.path));

        return (
            <li key={item.name} className={`nxl-item nxl-hasmenu ${isActiveParent ? 'active open' : ''}`}>
                <a
                    href="#"
                    className="nxl-link sidebar-tooltip"
                    data-bs-toggle="tooltip"
                    data-bs-trigger="hover"
                    data-bs-placement="left"
                    data-bs-container="body"
                    data-bs-title={item.description}
                >
                    <span className="nxl-micon"><i className={item.icon}></i></span>
                    <span className="nxl-mtext">{item.name}</span>
                    <span className="nxl-arrow"><i className="feather-chevron-left"></i></span>
                </a>
                <ul className="nxl-submenu" style={{ display: isActiveParent ? 'block' : 'none' }}>
                    {item.children.map(child => {
                        const isChildActive = currentPath === child.path || currentPath.startsWith(child.path);
                        return (
                            <li key={child.path} className={`nxl-item ${isChildActive ? 'active' : ''}`}>
                                <Link
                                    to={child.path}
                                    className="nxl-link sidebar-tooltip"
                                    data-bs-toggle="tooltip"
                                    data-bs-trigger="hover"
                                    data-bs-placement="left"
                                    data-bs-container="body"
                                    data-bs-title={child.description}
                                >
                                    <span className="nxl-mtext">{child.name}</span>
                                </Link>
                            </li>
                        );
                    })}
                </ul>
            </li>
        );
    };

    return (
        <nav className="nxl-navigation">
            <div className="navbar-wrapper">
                <div className="m-header">
                    <Link to="/" className="b-brand">
                        <img src="/assets/images/redesigned.png" alt="" className="avatar-xl logo logo-lg" />
                        <img src="/assets/images/redesigned.png" alt="" className="logo logo-sm" />
                    </Link>
                </div>
                <div className="navbar-content" style={{ overflowY: 'auto', overflowX: 'hidden', maxHeight: 'calc(100vh - 80px)' }}>
                    <ul className="nxl-navbar">
                        <li className="nxl-item nxl-caption">
                            <label>منوهای اصلی</label>
                        </li>
                        {menuItems.map(renderMenuItem)}
                    </ul>
                </div>
            </div>
        </nav>
    );
}

export default Sidebar;